"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _root_model = _interopRequireDefault(require("./root_model"));
var _membership_group = _interopRequireDefault(require("./membership_group"));
var _lodash = require("lodash");
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _navigation_item = _interopRequireDefault(require("./navigation_item"));
var _image = _interopRequireDefault(require("./image"));
var _favicon = _interopRequireDefault(require("./favicon"));
var _social_image = _interopRequireDefault(require("./social_image"));
var _podcast_image = _interopRequireDefault(require("./podcast_image"));
var _team_logo = _interopRequireDefault(require("./team_logo"));
var _email_banner = _interopRequireDefault(require("./email_banner"));
var _language = _interopRequireDefault(require("./language"));
var _banner_notice = _interopRequireDefault(require("./banner_notice"));
var _payment_migration_config = _interopRequireDefault(require("./payment_migration_config"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81, _descriptor82, _descriptor83, _descriptor84, _descriptor85, _descriptor86, _descriptor87, _descriptor88, _descriptor89; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Site = (_dec = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_navigation_item["default"]))), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_image["default"])), _dec3 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec4 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec5 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _dec6 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_banner_notice["default"]))), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_membership_group["default"])), _dec8 = (0, _serializr.serializable)((0, _serializr.object)(_favicon["default"])), _dec9 = (0, _serializr.serializable)((0, _serializr.object)(_social_image["default"])), _dec10 = (0, _serializr.serializable)((0, _serializr.object)(_podcast_image["default"])), _dec11 = (0, _serializr.serializable)((0, _serializr.object)(_email_banner["default"])), _dec12 = (0, _serializr.serializable)((0, _serializr.object)(_team_logo["default"])), _dec13 = (0, _serializr.serializable)((0, _serializr.object)(_language["default"])), _dec14 = (0, _serializr.serializable)((0, _serializr.object)(_payment_migration_config["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function Site() {
    var _this;
    _classCallCheck(this, Site);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Site, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "name", _descriptor2, _this);
    _initializerDefineProperty(_this, "teamName", _descriptor3, _this);
    _initializerDefineProperty(_this, "domainString", _descriptor4, _this);
    _initializerDefineProperty(_this, "stripeKey", _descriptor5, _this);
    _initializerDefineProperty(_this, "membershipGroupId", _descriptor6, _this);
    _initializerDefineProperty(_this, "currentWebVersion", _descriptor7, _this);
    _initializerDefineProperty(_this, "currentMobileVersion", _descriptor8, _this);
    _initializerDefineProperty(_this, "currentIosVersion", _descriptor9, _this);
    _initializerDefineProperty(_this, "currentAndroidVersion", _descriptor10, _this);
    _initializerDefineProperty(_this, "headerBackgroundColor", _descriptor11, _this);
    _initializerDefineProperty(_this, "headerButtonColor", _descriptor12, _this);
    _initializerDefineProperty(_this, "headerButtonHoverColor", _descriptor13, _this);
    _initializerDefineProperty(_this, "footerBackgroundColor", _descriptor14, _this);
    _initializerDefineProperty(_this, "navigationItems", _descriptor15, _this);
    _initializerDefineProperty(_this, "image", _descriptor16, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor17, _this);
    _initializerDefineProperty(_this, "accentColor", _descriptor18, _this);
    _initializerDefineProperty(_this, "secondaryAccentColor", _descriptor19, _this);
    _initializerDefineProperty(_this, "published", _descriptor20, _this);
    _initializerDefineProperty(_this, "paymentTestMode", _descriptor21, _this);
    _initializerDefineProperty(_this, "isDefault", _descriptor22, _this);
    _initializerDefineProperty(_this, "groupId", _descriptor23, _this);
    _initializerDefineProperty(_this, "forumId", _descriptor24, _this);
    _initializerDefineProperty(_this, "showWordPages", _descriptor25, _this);
    _initializerDefineProperty(_this, "showWordStress", _descriptor26, _this);
    _initializerDefineProperty(_this, "hideDefiniteArticle", _descriptor27, _this);
    _initializerDefineProperty(_this, "signedInHomePageRoute", _descriptor28, _this);
    _initializerDefineProperty(_this, "signedOutHomePageRoute", _descriptor29, _this);
    _initializerDefineProperty(_this, "supportEmailAddress", _descriptor30, _this);
    _initializerDefineProperty(_this, "fromEmailAddress", _descriptor31, _this);
    _initializerDefineProperty(_this, "patreonCampaignId", _descriptor32, _this);
    _initializerDefineProperty(_this, "patreonClientId", _descriptor33, _this);
    _initializerDefineProperty(_this, "patreonClientSecret", _descriptor34, _this);
    _initializerDefineProperty(_this, "patreonCreatorAccessToken", _descriptor35, _this);
    _initializerDefineProperty(_this, "patreonCreatorRefreshToken", _descriptor36, _this);
    _initializerDefineProperty(_this, "patreonWebhookSecret", _descriptor37, _this);
    _initializerDefineProperty(_this, "hasPodcast", _descriptor38, _this);
    _initializerDefineProperty(_this, "showWorksheetFilter", _descriptor39, _this);
    _initializerDefineProperty(_this, "showWorksheetComments", _descriptor40, _this);
    _initializerDefineProperty(_this, "showExerciseView", _descriptor41, _this);
    _initializerDefineProperty(_this, "discordServerId", _descriptor42, _this);
    _initializerDefineProperty(_this, "showLevelFilter", _descriptor43, _this);
    _initializerDefineProperty(_this, "showWordTypeFilter", _descriptor44, _this);
    _initializerDefineProperty(_this, "showAlphabeticalSort", _descriptor45, _this);
    _initializerDefineProperty(_this, "showChronologicalSort", _descriptor46, _this);
    _initializerDefineProperty(_this, "showLevelSort", _descriptor47, _this);
    _initializerDefineProperty(_this, "showLevelColumn", _descriptor48, _this);
    _initializerDefineProperty(_this, "showFrequencySort", _descriptor49, _this);
    _initializerDefineProperty(_this, "showAlternateTargetText", _descriptor50, _this);
    _initializerDefineProperty(_this, "showPlural", _descriptor51, _this);
    _initializerDefineProperty(_this, "alternateTargetTextName", _descriptor52, _this);
    _initializerDefineProperty(_this, "bccEmailAddresses", _descriptor53, _this);
    _initializerDefineProperty(_this, "youtubeUrl", _descriptor54, _this);
    _initializerDefineProperty(_this, "tikTokUrl", _descriptor55, _this);
    _initializerDefineProperty(_this, "instagramUrl", _descriptor56, _this);
    _initializerDefineProperty(_this, "podcastSettingsMessage", _descriptor57, _this);
    _initializerDefineProperty(_this, "blockVocabIfNotMigrated", _descriptor58, _this);
    _initializerDefineProperty(_this, "blockExercisesIfNotMigrated", _descriptor59, _this);
    _initializerDefineProperty(_this, "termsOfServiceUrl", _descriptor60, _this);
    _initializerDefineProperty(_this, "privacyUrl", _descriptor61, _this);
    _initializerDefineProperty(_this, "privacyTextHtml", _descriptor62, _this);
    _initializerDefineProperty(_this, "patreonMembershipPage", _descriptor63, _this);
    _initializerDefineProperty(_this, "blockPostNotifications", _descriptor64, _this);
    _initializerDefineProperty(_this, "allowPromotionCodes", _descriptor65, _this);
    _initializerDefineProperty(_this, "enableMailerlite", _descriptor66, _this);
    _initializerDefineProperty(_this, "automaticSyncingWithMailerlite", _descriptor67, _this);
    _initializerDefineProperty(_this, "syncAllUsersToMailerlite", _descriptor68, _this);
    _initializerDefineProperty(_this, "headerFont", _descriptor69, _this);
    _initializerDefineProperty(_this, "bodyFont", _descriptor70, _this);
    _initializerDefineProperty(_this, "earlyAccess", _descriptor71, _this);
    _initializerDefineProperty(_this, "earlyAccessToken", _descriptor72, _this);
    _initializerDefineProperty(_this, "enableLearningPaths", _descriptor73, _this);
    _initializerDefineProperty(_this, "learningPathsWelcomeTitleSignedIn", _descriptor74, _this);
    _initializerDefineProperty(_this, "learningPathsWelcomeTitleSignedOut", _descriptor75, _this);
    _initializerDefineProperty(_this, "learningPathsWelcomeSubtitleSignedIn", _descriptor76, _this);
    _initializerDefineProperty(_this, "learningPathsWelcomeSubtitleSignedOut", _descriptor77, _this);
    _initializerDefineProperty(_this, "leaderboardUpdatedAt", _descriptor78, _this);
    _initializerDefineProperty(_this, "didacticCountsLastUpdatedAt", _descriptor79, _this);
    _initializerDefineProperty(_this, "lastWebTriviaPublishedAt", _descriptor80, _this);
    _initializerDefineProperty(_this, "bannerNotices", _descriptor81, _this);
    _initializerDefineProperty(_this, "membershipGroup", _descriptor82, _this);
    _initializerDefineProperty(_this, "favicon", _descriptor83, _this);
    _initializerDefineProperty(_this, "socialImage", _descriptor84, _this);
    _initializerDefineProperty(_this, "podcastImage", _descriptor85, _this);
    _initializerDefineProperty(_this, "emailBanner", _descriptor86, _this);
    _initializerDefineProperty(_this, "teamLogo", _descriptor87, _this);
    _initializerDefineProperty(_this, "language", _descriptor88, _this);
    _initializerDefineProperty(_this, "paymentMigrationConfig", _descriptor89, _this);
    return _this;
  }
  _inherits(Site, _RootModel);
  return _createClass(Site, [{
    key: "whiteLabelTermsString",
    get: function get() {
      var postfix = ', and ';
      var links = [];
      if (this.termsOfServiceUrl) {
        links.push("<a href='".concat(this.termsOfServiceUrl, "' class='underline' target='_blank'>Terms</a>"));
      }
      if (this.privacyUrl) {
        links.push("<a href='".concat(this.privacyUrl, "'  class='underline' target='_blank'>Privacy Policy</a>"));
      }
      if (links.length > 0) {
        return "the ".concat(links.join(' & '), " of Easy Languages GmbH").concat(postfix);
      }
      return '';
    }
  }, {
    key: "daysSinceLastTriviaUpdate",
    get: function get() {
      return this.lastWebTriviaPublishedAt ? this.lastWebTriviaPublishedAt.daysSince : null;
    }
  }, {
    key: "transparentAccentColor",
    get: function get() {
      return "".concat(this.accentColor, "a1");
    }
  }, {
    key: "earlyAccessUrl",
    get: function get() {
      if (!this.earlyAccessToken) {
        return null;
      }
      return "https://".concat(this.domainString, "/access/").concat(this.earlyAccessToken);
    }
  }, {
    key: "teamInitials",
    get: function get() {
      return this.teamName.split(' ').map(function (name) {
        return name[0];
      }).join('');
    }
  }], [{
    key: "defaultSiteId",
    value: function defaultSiteId() {
      return '1a441cc2-da7f-40ed-8b30-6b231c046181';
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "teamName", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "domainString", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "stripeKey", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "membershipGroupId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentWebVersion", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "currentMobileVersion", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "currentIosVersion", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "currentAndroidVersion", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "headerBackgroundColor", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "headerButtonColor", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "headerButtonHoverColor", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "footerBackgroundColor", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "navigationItems", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "image", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "accentColor", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "secondaryAccentColor", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "published", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "paymentTestMode", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "isDefault", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "groupId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "forumId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "showWordPages", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "showWordStress", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "hideDefiniteArticle", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "signedInHomePageRoute", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "signedOutHomePageRoute", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "supportEmailAddress", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "fromEmailAddress", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "patreonCampaignId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "patreonClientId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "patreonClientSecret", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "patreonCreatorAccessToken", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "patreonCreatorRefreshToken", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "patreonWebhookSecret", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "hasPodcast", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "showWorksheetFilter", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "showWorksheetComments", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "showExerciseView", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "discordServerId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "showLevelFilter", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "showWordTypeFilter", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "showAlphabeticalSort", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "showChronologicalSort", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "showLevelSort", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "showLevelColumn", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "showFrequencySort", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "showAlternateTargetText", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "showPlural", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "alternateTargetTextName", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "bccEmailAddresses", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "youtubeUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "tikTokUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "instagramUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "podcastSettingsMessage", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "blockVocabIfNotMigrated", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "blockExercisesIfNotMigrated", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "termsOfServiceUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "privacyUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "privacyTextHtml", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "patreonMembershipPage", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "blockPostNotifications", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "allowPromotionCodes", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "enableMailerlite", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "automaticSyncingWithMailerlite", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "syncAllUsersToMailerlite", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "headerFont", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "bodyFont", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "earlyAccess", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "earlyAccessToken", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "enableLearningPaths", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "learningPathsWelcomeTitleSignedIn", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "learningPathsWelcomeTitleSignedOut", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "learningPathsWelcomeSubtitleSignedIn", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "learningPathsWelcomeSubtitleSignedOut", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "leaderboardUpdatedAt", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "didacticCountsLastUpdatedAt", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "lastWebTriviaPublishedAt", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class.prototype, "bannerNotices", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor82 = _applyDecoratedDescriptor(_class.prototype, "membershipGroup", [_mobx.observable, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor83 = _applyDecoratedDescriptor(_class.prototype, "favicon", [_mobx.observable, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor84 = _applyDecoratedDescriptor(_class.prototype, "socialImage", [_mobx.observable, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor85 = _applyDecoratedDescriptor(_class.prototype, "podcastImage", [_mobx.observable, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor86 = _applyDecoratedDescriptor(_class.prototype, "emailBanner", [_mobx.observable, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor87 = _applyDecoratedDescriptor(_class.prototype, "teamLogo", [_mobx.observable, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor88 = _applyDecoratedDescriptor(_class.prototype, "language", [_mobx.observable, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor89 = _applyDecoratedDescriptor(_class.prototype, "paymentMigrationConfig", [_mobx.observable, _dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "whiteLabelTermsString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "whiteLabelTermsString"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "daysSinceLastTriviaUpdate", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "daysSinceLastTriviaUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transparentAccentColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "transparentAccentColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "earlyAccessUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "earlyAccessUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teamInitials", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "teamInitials"), _class.prototype), _class);
var _default = exports["default"] = Site;